import { Box, Grid2 as Grid, Stack } from "@mui/material";
import { Customer } from "../../store/services/customerService";
import Communications from "../customer-contacts/v2/Communications";
import NextActionCard from "../next-action/NextActionCard";
import CustomerNotesCard from "./components/CustomerNotesCard";
import MixedTimeline from "./components/MixedTimeline";
import QuickInfoCard from "./components/QuickInfoCard";

interface CustomerProfileDesktopProps {
  customer: Customer;
  isCompany?: boolean;
}

const CustomerProfileDesktop = ({
  customer,
  isCompany,
}: CustomerProfileDesktopProps) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={3}>
        <Grid container size={{ xs: 12, md: 4 }}>
          <Stack spacing={3} sx={{ width: "100%" }}>
            <QuickInfoCard customer={customer} />
            <Communications
              customerNo={customer.CustomerNo}
              isCompany={isCompany}
            />
            <CustomerNotesCard customerNo={customer.CustomerNo} />

            <NextActionCard customerNo={customer.CustomerNo} />
          </Stack>
        </Grid>
        <Grid container size={{ xs: 12, md: 8 }}>
          <Stack spacing={3} sx={{ width: "100%" }}>
            <MixedTimeline customerNo={customer.CustomerNo} />
          </Stack>
        </Grid>
      </Grid>

    </Box>
  );
};
export default CustomerProfileDesktop;
